window._ = require('lodash');
import './axios';
import './dinero';
import './enums';
import './json-api-query';
import './v-tooltip';
import './vue-meta';
import './vue-moment';
import './vue-portal';
import './vue-toastification';
import './sentry';
